import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const RemoveCircleGlyph = /*#__PURE__*/createElement("g", {
  id: "remove_circle"
}, /*#__PURE__*/createElement("path", {
  d: "M58.3,40.5H25.7c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h32.6c0.8,0,1.5-0.7,1.5-1.5S59.1,40.5,58.3,40.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,18c13.2,0,24,10.8,24,24S55.2,66,42,66S18,55.2,18,42S28.8,18,42,18 M42,15c-14.9,0-27,12.1-27,27s12.1,27,27,27 s27-12.1,27-27S56.9,15,42,15L42,15z"
}));
const RemoveCircle = createSvg({
  name: 'remove_circle',
  path: RemoveCircleGlyph
});

export default RemoveCircle;
export { RemoveCircleGlyph };
